"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styles = require("@material-ui/core/styles");
var _helpers = require("../utilities/helpers");
var _base = _interopRequireDefault(require("./base"));
var _palette = _interopRequireDefault(require("./light/palette"));
var _palette2 = _interopRequireDefault(require("./dark/palette"));
var _typography2 = _interopRequireDefault(require("./typography"));
var _accessibility = _interopRequireDefault(require("./accessibility"));
var _box = _interopRequireDefault(require("./box"));
var _button = _interopRequireDefault(require("./button"));
var _get = _interopRequireDefault(require("../poly/get"));
const createTypographyOverwrites = (breakpoints, _typography) => {
  let overwrites = {};
  Object.entries(_typography).forEach(function ([key, value]) {
    overwrites[key] = {
      [breakpoints.up('md')]: (0, _extends2.default)({}, value)
    };
  });
  return overwrites;
};
const themeType = {
  'light': _palette.default,
  'dark': _palette2.default
};
const ThemeFactory = (type = 'light', newTheme = {}) => {
  const mergedtheme = (0, _styles.createMuiTheme)((0, _helpers.deepmerge)(_base.default, {
    accessibility: _accessibility.default,
    typography: _typography2.default.base
  }, {
    palette: themeType[type]
  }, newTheme));
  return (0, _helpers.deepmerge)((0, _button.default)(mergedtheme),
  // Put above mergedTheme for button color different than primary
  mergedtheme, (0, _box.default)(mergedtheme), {
    overrides: {
      MuiTypography: createTypographyOverwrites(mergedtheme.breakpoints, (0, _helpers.deepmerge)(_typography2.default.overwrites, (0, _get.default)(newTheme, 'typography.desktop', {}))),
      MuiFormLabel: {
        root: {
          fontSize: '1em'
        }
      }
    }
  });
};
var _default = exports.default = ThemeFactory;